(function ($) {
	var popovers = $('.js-popover');
	var TAB_KEY_CODE = 9;

	var lockTabFocus = function(contentOverlay) {
		var $focusableElements = $(contentOverlay).find('a[href], button');

		$focusableElements.first().focus();

		$focusableElements.first().keydown(function(e) {
			if (e.shiftKey && e.keyCode === TAB_KEY_CODE) {
				e.preventDefault();
				$focusableElements.last().focus();
			}
		});

		$focusableElements.last().keydown(function(e) {
			if (e.keyCode === TAB_KEY_CODE && !e.shiftKey) {
				e.preventDefault();
				$focusableElements.first().focus();
			}
		});
	};

	popovers.each(function (i, ele) {
		var toggleBtn = $(ele).find('.js-toggle-popover');
		var contentOverlay = $(ele).find('.js-pop-over-container');

		toggleBtn.on('click', function () {
			document.body.style.borderRight = (window.innerWidth - document.body.offsetWidth) + 'px solid #f8f8f8';
			document.body.style.top = '-' + window.pageYOffset + 'px';
			document.body.style.width = '100%';
			document.body.style.position = 'fixed';

			contentOverlay.hide();
			contentOverlay.removeClass('open');
			contentOverlay.addClass('open');
			contentOverlay.show();
			lockTabFocus(contentOverlay);
		});

		contentOverlay.on('click', function () {
			contentOverlay.hide();
			var scrollY = document.body.style.top;
			document.body.style.borderRight = '';
			document.body.style.top = '';
			document.body.style.width = '';
			document.body.style.position = '';
			window.scrollTo(0, parseInt(scrollY || '0') * -1);
		});

		contentOverlay.find('.content').on('click', function (e) {
			e.stopPropagation();
		});
    });
})(jQuery);
